import { useParams } from 'react-router-dom';

import SupplierCertificateDetailsPage from '../../../../../supplier-certificate-details/SupplierCertificateDetailsPage';
import SupplierCertificatesTable from './components/supplier-certificates-table/SupplierCertificatesTable';

const SupplierCertificatesTab = (): JSX.Element => {
  const { certificateId } = useParams() as { certificateId?: string };

  if (certificateId) {
    return <SupplierCertificateDetailsPage />;
  }

  return (
    <div className='flex flex-column'>
      <SupplierCertificatesTable />
    </div>
  );
};

export default SupplierCertificatesTab;
